import React, { useState, useRef } from "react";
// import ReactJWPlayer from "react-jw-player";
import Global from "../../global";
import { UserStore } from "../store/store";
import Progress from "../history/progress";
import useWatchHistory from "../../hooks/useWatchHistory";
import useCheckBoxedVideo from "../../hooks/useCheckBoxedVideo";
import { Link } from "react-router-dom";
import LazyDiv from "../lazy/lazydiv";
import JWPlayer from "@jwplayer/jwplayer-react";
import { addForwardButton } from "../javascript/function";

const BoxedPlayer = (props) => {
  const currentUser = UserStore.useState((s) => s.user);
  const videoDetail = useRef(props.videoData);
  const videoAccess = useCheckBoxedVideo(videoDetail.current);
  const [mounted, setMounted] = useState(false);

  const videoIndex = useRef(
    currentUser.WATCHHISTORY.findIndex(
      (obj) => obj.video_id === props.match.params.Id
    )
  );
  const playerRef = useRef({});
  const seeked = useRef(
    videoIndex.current === -1
      ? 0
      : parseInt(currentUser.WATCHHISTORY[videoIndex.current].position)
  );
  const videoRef = useRef(
    props.match.params.Type === "season"
      ? "https://cdn.jwplayer.com/v2/playlists/" + props.match.params.Id
      : props.match.params.Type === "episode"
      ? props.match.params.offset
        ? "https://cdn.jwplayer.com/v2/playlists/" +
          props.match.params.TypeId +
          "?page_offset=" +
          props.match.params.offset
        : "https://cdn.jwplayer.com/v2/playlists/" + props.match.params.TypeId
      : "https://cdn.jwplayer.com/v2/media/" + props.match.params.Id
  );
  const [videoName, SetVideoname] = useState("");
  const [media_id, SetVideo_ID] = useState(props.match.params.Id);
  const [seek, setSeek] = useState(Global.RPB ? seeked.current : 0);
  let date = new Date();
  let cdate = date.toDateString();
  let ctime = date.toTimeString();
  Progress.video_id = props.match.params.Id;
  Progress.duration =
    videoIndex.current === -1 ||
    isNaN(parseInt(currentUser.WATCHHISTORY[videoIndex.current].duration))
      ? 0
      : parseInt(currentUser.WATCHHISTORY[videoIndex.current].duration);
  Progress.position =
    videoIndex.current === -1 ||
    isNaN(parseInt(currentUser.WATCHHISTORY[videoIndex.current].position))
      ? 0
      : parseInt(currentUser.WATCHHISTORY[videoIndex.current].position);
  Progress.type =
    props.match.params.Type === "season" ||
    props.match.params.Type === "episode"
      ? "season"
      : "";
  Progress.list_id =
    props.match.params.Type === "season"
      ? props.match.params.Id
      : props.match.params.Type === "episode"
      ? props.match.params.TypeId
      : "";
  Progress.date = cdate + " " + ctime;
  Progress.limit = props.match.params.offset ? props.match.params.offset : "";
  Progress.title = videoName;
  const [second, Setsecond] = useState(Progress);
  useWatchHistory(second);

  const readyPlay = (event) => {
    SetVideoname(event.item.title);

    if (
      props.match.params.Type === "season" ||
      props.match.params.Type === "episode"
    ) {
      SetVideo_ID(event.item.mediaid);
      const index = currentUser.WATCHHISTORY.findIndex(
        (obj) => obj.video_id === props.match.params.Id
      );
      if (index > -1) {
        const arr = [...currentUser.WATCHHISTORY];
        arr.splice(index, 1);
      }
    }

    const objIndex = currentUser.WATCHHISTORY.findIndex(
      (obj) => obj.video_id === media_id
    );
    if (objIndex > -1) {
      setSeek(parseInt(currentUser.WATCHHISTORY[objIndex].position));
    } else {
      setSeek(0);
    }

    // }
  };

  const onReady = (event) => {
    if (mounted) {
      playerRef.current.seek(seek);
      addForwardButton(playerRef.current);
    }
  };
  const playerMountedCallback = ({ player }) => {
    playerRef.current = player;
    setMounted(true);
  };
  const playerUnmountingCallback = ({ player }) => {
    playerRef.current = null;
    setMounted(false);
  };

  const watchedHistory = (event) => {
    const obj = {
      duration: event.duration,
      position: event.position,
      video_id: media_id,
      type:
        props.match.params.Type === "season" ||
        props.match.params.Type === "episode"
          ? "season"
          : "",
      list_id:
        props.match.params.Type === "season"
          ? props.match.params.Id
          : props.match.params.Type === "episode"
          ? props.match.params.TypeId
          : "",
      date: cdate + " " + ctime,
      limit: props.match.params.offset ? props.match.params.offset : "",
      title: videoName,
    };
    Setsecond(obj);
  };

  if (videoAccess === "Access") {
    return (
      <div
        className={props.header ? "boxClassTop" : "boxClass"}
        style={{ paddingTop: Global.TYPE === "News" ? "2rem" : "" }}
      >
        <JWPlayer
          library={"https://cdn.jwplayer.com/libraries/" + Global.FSP + ".js"}
          playlist={videoRef.current}
          onTime={watchedHistory}
          onPlaylistItem={readyPlay}
          onReady={onReady}
          didMountCallback={playerMountedCallback}
          playerUnmountingCallback={playerUnmountingCallback}
        ></JWPlayer>
      </div>
    );
  } else if (videoAccess !== null) {
    return (
      <div className="boxPrevWrap">
        <LazyDiv
          className="boxPreview text-center v-middle"
          style={{
            width: "100%",
            height: "100%",
            background:
              `url(https://cdn.jwplayer.com/v2/media/` +
              props.match.params.Id +
              `/poster.jpg?width=720) var(--iq-rgba-element-body)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <Link
            to={
              videoAccess === "Login"
                ? "/" +
                  props.match.params.AppId +
                  "/login?redirect=" +
                  props.videoData.playlist[0].mediaid +
                  "&type=video&after=login"
                : videoAccess === "Login with Premium"
                ? "/" +
                  props.match.params.AppId +
                  "/login?redirect=" +
                  props.videoData.playlist[0].mediaid +
                  "&type=video&after=premium"
                : "/" +
                  props.match.params.AppId +
                  "/premium/" +
                  props.videoData.playlist[0].AssetId +
                  "?redirect=" +
                  props.videoData.playlist[0].mediaid +
                  "&type=video&after=premium"
            }
            className="btn btn-hover"
          >
            {videoAccess === "Login"
              ? "Login to Watch"
              : videoAccess === "Login with Premium"
              ? "Login & Subscribe"
              : "Complete Subscription"}
          </Link>
          <div className="boxOverlay"></div>
        </LazyDiv>
      </div>
    );
  } else {
    return <div></div>;
  }
};

export default BoxedPlayer;
